<template>
  <div id="app" class="background has-background-dark">
    <section class="hero is-medium is-primary prim-background">
      <nav
        class="navbar is-fixed-top"
        role="navigation"
        aria-label="dropdown navigation"
      >
        <div class="navbar-brand">
          <a class="navbar-item" @click="() => $router.push('/')">
            <h3
              style="color: #EFDE00;text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);"
            >
              {{ $t("APP_NAME") }}
            </h3>
          </a>
          <a
            @click="menu = !menu"
            role="button"
            style="color: white"
            :class="'navbar-burger ' + (menu ? 'is-active' : '')"
            aria-label="menu"
            aria-expanded="false"
          >
            <span style="color: white" aria-hidden="true"></span>
            <span style="color: white" aria-hidden="true"></span>
            <span style="color: white" aria-hidden="true"></span>
          </a>
        </div>
        <div
          :class="'is-pulled-right navbar-menu ' + (menu ? 'is-active' : '')"
        >
          <div class="navbar-end">
            <div :class="'navbar-item ' + (showLang ? 'is-active' : '')">
              <a class="navbar-link" @click="showLang = !showLang">
                <country-flag
                  :country="selectedCountry.key"
                  size="small"
                ></country-flag>
                {{ $t(selectedCountry.value) }}
              </a>

              <div class="navbar-dropdown" v-if="showLang">
                <a
                  class="navbar-item is-arrowless"
                  @click="setLanguageLocale(country)"
                  v-for="country in countries"
                  v-bind:key="country.key"
                >
                  <div class="language-flag">
                    <country-flag
                      :country="country.key"
                      size="small"
                    ></country-flag>
                  </div>
                  <div class="language-name">
                    <a class="navbar-link is-arrowless">
                      {{ $t(country.value) }}
                    </a>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <nav
        v-if="showCookies"
        class="has-background-dark navbar is-fixed-bottom cookies-bottom-bar"
      >
        <div>
          {{ $t("COOKIES_MESSAGE") }}
        </div>
        <div class="cookies-buttons">
          <a
            @click="() => $router.push('/cookies')"
            class="button null-bg is-success"
          >
            {{ $t("COOKIES_BUTTON_SHOW") }}
          </a>
          <button class="button is-info" @click="acceptCookies">
            {{ $t("COOKIES_BUTTON_ACCEPT") }}
          </button>
        </div>
      </nav>
    </section>
    <router-view />
    <section class="hero is-medium is-primary bottom-bg">
      <div class="hero-body">
        <div class="container">
          <h3 class="title has-text-centered">{{ $t("SECTION_6_TITLE") }}</h3>
          <p
            class="subtitle has-text-centered mt-3"
            v-html="parseMessageToHtml('SECTION_6_MESSAGE')"
          />
          <div class="columns mt-3 is-center is-centered is-grouped-centered">
            <div class="column"></div>
            <div class="column">
              <a :href="$t('ANDROID_STORE_LINK')" target="_blank">
                <SVGImage SVGFile="android_badge.png"></SVGImage>
              </a>
            </div>
            <div class="column">
              <a :href="$t('IOS_STORE_LINK')" target="_blank">
                <SVGImage SVGFile="ios_badge.png"></SVGImage>
              </a>
            </div>
            <div class="column"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-small is-primary footer-section-bg">
      <div class="hero-body">
        <div class="container">
          <div class="footer-logos-content">
            <div class="footer-creators-logos">
              <h5 class="footer-text">{{ $t("CREATED_BY") }}</h5>
              <div class="creators-logos">
                <div class="creator-logo">
                  <SVGImage SVGFile="patro_1.png"></SVGImage>
                </div>
                <a
                  class="creator-logo big-creator"
                  href="https://eu-jamrai.eu/"
                >
                  <SVGImage SVGFile="patro_2.png"></SVGImage>
                </a>
                <div class="creator-logo small-creator">
                  <SVGImage SVGFile="patro_3.png"></SVGImage>
                </div>
                <div class="creator-logo">
                  <SVGImage SVGFile="patro_4.png"></SVGImage>
                </div>
                <div class="creator-logo">
                  <SVGImage SVGFile="patro_6.png"></SVGImage>
                </div>
              </div>
            </div>
            <div class="footer-developer-logos">
              <h5 class="footer-text">{{ $t("DESIGNED_AND_DEVELOP_BY") }}</h5>
              <div class="creators-logos">
                <div class="creator-logo">
                  <SVGImage SVGFile="patro_5.png"></SVGImage>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer footer-bg pl-6">
      <div class="content">
        <div class="columns is-vcentered is-centered is-center has-text-left">
          <div class="column is-8">
            <p class="subtitle footer-text-bottom">
              {{ $t("FOOTER_MESSAGE") }}
            </p>
            <p class="subtitle footer-text">
              <a
                class="subtitle is-link footer-text-bottom"
                @click="() => $router.push('/legal')"
              >
                {{ $t("LEGAL_ADVISOR") }}
              </a>
              |
              <a
                class="subtitle is-link footer-text-bottom"
                @click="() => $router.push('/privacy')"
              >
                {{ $t("PRIVACY_POLICY") }}
              </a>
              |
              <a
                class="subtitle is-link footer-text-bottom"
                @click="() => $router.push('/cookies')"
              >
                {{ $t("COOKIE_POLICY") }}
              </a>
            </p>
          </div>
          <div class="column is-1">
            <a :href="'mailto:' + $t('CONTACT_EMAIL')">
              <h4 class="subtitle mb-0">{{ $t("CONTACT") }}</h4>
            </a>
          </div>
          <div class="column is-3">
            <div class="social-container">
              <div class="social-source-name">{{ $t("ISG_NAME") }}</div>
              <div class="social-source-buttons">
                <div v-if="$t('ISG_FACEBOOK_LINK')" class="social">
                  <a :href="$t('ISG_FACEBOOK_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Facebook.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
                <div v-if="$t('ISG_TWITTER_LINK')" class="social">
                  <a :href="$t('ISG_TWITTER_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Twitter.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
                <div v-if="$t('ISG_LINKEDIN_LINK')" class="social">
                  <a :href="$t('ISG_LINKEDIN_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Linkedin.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
                <div v-if="$t('ISG_INSTAGRAM_LINK')" class="social">
                  <a :href="$t('ISG_INSTAGRAM_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Instagram.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
                <div v-if="$t('ISG_YOUTUBE_LINK')" class="social">
                  <a :href="$t('ISG_YOUTUBE_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Youtube.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
              </div>
              <div class="social-source-name">{{ $t("EUJ_NAME") }}</div>
              <div class="social-source-buttons">
                <div v-if="$t('EUJ_FACEBOOK_LINK')" class="social">
                  <a :href="$t('EUJ_FACEBOOK_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Facebook.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
                <div v-if="$t('EUJ_TWITTER_LINK')" class="social">
                  <a :href="$t('EUJ_TWITTER_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Twitter.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
                <div v-if="$t('EUJ_LINKEDIN_LINK')" class="social">
                  <a :href="$t('EUJ_LINKEDIN_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Linkedin.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
                <div v-if="$t('EUJ_INSTAGRAM_LINK')" class="social">
                  <a :href="$t('EUJ_INSTAGRAM_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Instagram.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
                <div v-if="$t('EUJ_YOUTUBE_LINK')" class="social">
                  <a :href="$t('EUJ_YOUTUBE_LINK')" target="_blank">
                    <SVGImage
                      SVGFile="Youtube.png"
                      class="footer-image"
                    ></SVGImage>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import SVGImage from "./components/SVGImage";
import CountryFlag from "vue-country-flag";
import { languageList } from "./translations";

export default {
  name: "home",
  components: {
    SVGImage,
    CountryFlag
  },
  data() {
    return {
      menu: false,
      showLang: false,
      selectedCountry: languageList[1],
      countries: languageList,
      showCookies: false
    };
  },
  mounted() {
    this.selectedCountry = localStorage.getObject("country") || languageList[1];
    let policy = window.localStorage.getItem("COOKIES_POLICY");
    this.showCookies = policy !== "TRUE";
  },
  methods: {
    setLanguageLocale(country) {
      this.selectedCountry = country;
      localStorage.setObject("country", country);
    },
    acceptCookies() {
      window.localStorage.setItem("COOKIES_POLICY", "TRUE");
      this.showCookies = false;
    },
    parseMessageToHtml(key) {
      return this.$t(key).replace(/\n/g, "<br />");
    },
    parseWordForLink(key, word, url) {
      const linkTag = '<a href="' + url + '" target="_blank">' + word + "</a>";
      return this.parseMessageToHtml(key).replace(word, linkTag);
    }
  },
  watch: {
    selectedCountry(oldCountry) {
      this.$i18n.locale = oldCountry.key;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

a {
  font-weight: bold;
  color: #2c3e50;

  &.router-link-exact-active {
    color: #42b983;
  }
}

.title {
  color: white !important;
}

.subtitle {
  color: white !important;
}

.mc-icon {
  border: 8px solid #f08100;
  box-sizing: border-box;
  box-shadow: 0 7px 20px rgba(0, 0, 0, 0.35);
  border-radius: 8px;
}

.ctr-button {
  background: linear-gradient(360deg, #f08100 6.67%, #f2d079 90%);
  border-radius: 63.45px;
  text-align: center;
  text-transform: uppercase;
  color: #004e63;
  font-size: 24px;
  padding: 0 40px !important;
  margin-top: 40px;
  border: none !important;
}

.background {
  background: radial-gradient(
    68.32% 36.06% at 50% 50%,
    #00beeb 1.56%,
    #0182a8 100%
  ) !important;
}

.footer {
  padding: 3rem;
}

.footer-text {
  font-size: medium;
  color: white !important;
}

.prim-background {
  background: url("assets/prim_background.png") center top !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}

.bottom-bg {
  background: url("assets/bottom_bg.png") center top !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}

.null-bg {
  background: url("assets/overlay_bg.png") center top !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}

.navbar-dropdown {
  background: none !important;
  border-top: none !important;
}

.navbar-link {
  color: white !important;
  background: none !important;
}

.hero.is-primary a.navbar-item:hover,
.hero.is-primary a.navbar-item.is-active,
.hero.is-primary .navbar-link:hover,
.hero.is-primary .navbar-link.is-active {
  background: none !important;
}

.navbar {
  background: rgba(0, 0, 0, 0.2) !important;
  backdrop-filter: blur(20px) !important;
}

.navbar-menu {
  margin-right: 2px !important;
  color: white !important;
  border-radius: 4px !important;
  width: 25%;
  background: none !important;
  box-shadow: none !important;
}

.navbar-dropdown {
  margin-right: 2px !important;
  background: rgba(0, 0, 0, 0.2) !important;
  backdrop-filter: blur(20px) !important;
  color: white !important;
  border-radius: 4px !important;
}

.navbar-dropdown .language-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  padding-right: 0 !important;
  padding-left: 0 !important;
}

.footer-logos-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;

  padding: 20px 0;
}

.footer-logos-content .footer-creators-logos,
.footer-logos-content .footer-developer-logos {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.footer-logos-content .footer-creators-logos {
  margin-right: 20px;
}

.creators-logos {
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

.creators-logos .creator-logo {
  margin: 50px 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.creators-logos .creator-logo:not(:last-child) {
  margin-right: 10px;
}

.creators-logos .creator-logo .responsive-img {
  width: 75%;
}

.creators-logos .creator-logo.big-creator .responsive-img {
  /*flex: 1.5;*/
  width: 140%;
}

.creators-logos .creator-logo.small-creator {
  align-items: center;
}

.creators-logos .creator-logo.small-creator .responsive-img {
  /*flex: 0.5;*/
  width: 40%;
}

.footer-section-bg {
  background: rgba(1, 0, 0, 0.47) !important;
}

.footer-bg {
  background: rgba(1, 0, 0, 0.71) !important;
}

.footer-text {
  color: #4ab6d6 !important;
  text-align: start !important;
}

.footer-text-bottom {
  color: white !important;
  font-size: 16px;
}

.social-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
}

.social-source-name {
  color: white;
}

.social-source-buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.footer-image {
  max-height: 40px;
  margin-right: 10px;
}

.cookies-bottom-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 15px 50px;
}

.cookies-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.legal-section .hero {
  text-align: left;
  padding: 5rem;
}

.legal-section h1 {
  font-size: 2rem;
  text-align: center;
  text-transform: uppercase;
  margin: 2rem 0;
}

.legal-section h2 {
  font-size: 1.5rem;
  text-transform: uppercase;
  margin-bottom: 2rem;
}

.legal-section h3 {
  font-size: 1.25rem;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.legal-section h4 {
  font-size: 1.15rem;
  margin-top: 1rem !important;
  margin-left: 0.75rem;
}

.legal-section ol {
  counter-reset: item;
  /*margin-top: 1rem;*/
  font-size: 1.5rem;
  font-family: "Chewy", cursive !important;
  text-shadow: 0px 4px 4px rgba(95, 42, 136, 0.25);
}

.legal-section ol li {
  display: block;
  margin-top: 1rem !important;
}

.legal-section ol li ol {
  font-size: 1rem;
  font-family: Roboto, sans-serif !important;
  text-shadow: none;
}

.legal-section ol li:before {
  content: counters(item, ".") " ";
  counter-increment: item;
}

.legal-section ul li {
  list-style-type: disc;
  margin-top: 1rem !important;
  margin-left: 2rem;
}

@media all and (max-width: 777px) {
  .prim-background {
    background-size: auto 100% !important;
  }

  .mc-icon {
    width: 50% !important;
  }

  .null-bg {
    background: none !important;
  }

  .bottom-bg {
    background-size: auto 100% !important;
  }
  .navbar-menu {
    width: 50%;
  }
  .language-flag,
  .flag {
    display: none;
  }
  .footer {
    padding: 1.5rem !important;
  }
  .cookies-bottom-bar {
    padding: 20px 10px;

    flex-direction: column;
    justify-content: center;
  }
  .cookies-bottom-bar div {
    padding: 5px !important;
  }

  .footer-logos-content,
  .creators-logos {
    flex-wrap: wrap;
  }
  .creators-logos .creator-logo {
    align-items: center;
  }
  .creators-logos .creator-logo:not(:last-child) {
    margin-right: 0;
  }
}
</style>
